import React from 'react';

export const TypeUnknown: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 12.6667C1.9999 13.0203 2.14024 13.3594 2.39016 13.6094C2.64007 13.8595 2.97907 14 3.3326 14.0001H3.33333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.00002 9.1134V10.4467"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.00002 5.55334V6.88668"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.55334 14.0001H6.88668"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.55334 2.00002H6.88668"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6667 14.0001C13.0202 14.0002 13.3593 13.8598 13.6093 13.6099C13.8594 13.36 13.9999 13.021 14 12.6675V12.6667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 3.33333C14.0001 2.97981 13.8598 2.64072 13.6099 2.39067C13.36 2.14063 13.0209 2.0001 12.6674 2H12.6667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 6.88668V5.55334"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 10.4467V9.1134"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4467 2.00002H9.11334"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4467 14.0001H9.11334"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33333 2C2.97981 1.9999 2.64072 2.14024 2.39067 2.39016C2.14063 2.64007 2.0001 2.97907 2 3.3326"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.86475 9.86719C8.03293 9.8672 8.17958 9.92928 8.29932 10.0488C8.41897 10.1685 8.48078 10.3153 8.48096 10.4834C8.48096 10.5949 8.45243 10.6996 8.39502 10.7939C8.34083 10.886 8.26702 10.9606 8.17529 11.0166C8.08217 11.0725 7.97709 11.0996 7.86475 11.0996C7.69657 11.0996 7.5499 11.0385 7.43018 10.9189C7.31052 10.7992 7.24854 10.6517 7.24854 10.4834C7.24871 10.3153 7.31052 10.1685 7.43018 10.0488C7.54991 9.92925 7.69656 9.86722 7.86475 9.86719Z"
      fill="currentColor"
    />
    <path
      d="M8.0249 4.90039C8.37469 4.90039 8.68505 4.96933 8.95068 5.1123C9.21614 5.25415 9.42233 5.4507 9.56787 5.7002C9.71547 5.95029 9.78852 6.23468 9.78857 6.54883C9.78857 6.76933 9.75494 6.9722 9.68506 7.15527C9.61778 7.33641 9.51943 7.49877 9.39111 7.6416C9.2654 7.78354 9.11376 7.90873 8.93799 8.0166C8.77652 8.11761 8.65023 8.22208 8.55713 8.3291L8.55615 8.33008C8.46546 8.43277 8.39904 8.55668 8.35693 8.70215C8.31438 8.84942 8.2894 9.03809 8.28564 9.26953V9.40234H7.39795V9.2666C7.40185 8.89684 7.43982 8.59426 7.51709 8.36426C7.59367 8.13665 7.70437 7.94651 7.85107 7.7998C7.99141 7.65951 8.15889 7.53134 8.35205 7.41504C8.45743 7.35068 8.5516 7.27471 8.63525 7.1875C8.71626 7.10111 8.78068 7.00173 8.82764 6.88867L8.82861 6.8877C8.87601 6.77748 8.90084 6.65336 8.90088 6.51465C8.90082 6.34388 8.86064 6.20019 8.78467 6.08105C8.70647 5.95878 8.60154 5.86437 8.47021 5.79785C8.33832 5.73113 8.19019 5.69629 8.0249 5.69629C7.8826 5.69636 7.7453 5.72588 7.61279 5.78516C7.48527 5.84222 7.3774 5.93292 7.28955 6.05859C7.20554 6.17904 7.15266 6.3428 7.13818 6.55566L7.13232 6.64844H6.21143L6.21631 6.54395C6.23236 6.20426 6.32044 5.9069 6.48486 5.6582C6.64967 5.4121 6.86809 5.22376 7.13623 5.09375C7.40513 4.9644 7.70191 4.90046 8.0249 4.90039Z"
      fill="currentColor"
    />
  </svg>
);
